import React from 'react'
import { styled, Grid as BaseGrid } from '@mui/material'

export const Column = styled(({ flexGrow, margin, padding, width, ...props }) => <BaseGrid {...props} item />)`
  flex-grow: ${props => props.flexGrow ?? ''};
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '0 5px'};
  width: ${props => props.width};
`

export const ColumnButton = styled(({ flexGrow, margin, padding, width, ...props }) => <BaseGrid {...props} />)`
  flex-grow: ${props => props.flexGrow ?? ''};
  margin: ${props => props.margin || '0'};
  padding: 0 0 0 10px;
  width: ${props => props.width};
`

export const Form = styled('form')`
  display: flex;
  width: 100%;
`

export const Row = styled(({ margin, padding, ...props }) => <BaseGrid container {...props} />)`
  align-items: center;
  flex-direction: ${props => props.flexDirection};
  flex-wrap: nowrap;
  gap: 20px;
  justify-content: flex-start;
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '0'};

  ${props => props.theme.breakpoints.down('sm')} {
    align-items: start;
    flex-direction: column;
    gap: 10px;
  }
`
